import React from 'react';
import styled from 'styled-components';

type Props = {
    children: any;
    className?: string;
};

const InvoiceSummaryList = ({ children, className }: Props) => {
    return <StyledInvoiceSummaryList className={className}>{children}</StyledInvoiceSummaryList>;
};

export default InvoiceSummaryList;

const StyledInvoiceSummaryList = styled.div`
    display: flex;
    flex-direction: column;
`;
